import axios from "../api/axios";
import { useEffect, useState } from "react";

const useCountriesList = () => {
  const [countriesList, setCountriesList] = useState();
  useEffect(() => {
    (async () => {
      const res = await getCountriesList();
      setCountriesList(res)
    })()
  }, [])
  const getCountriesList = async () => {
    try {
      const { data } = await axios.get('/countries');
      return data.countries
    } catch (error) {
      console.error(error);
      throw error
    }
  }

  return countriesList;
}

export default useCountriesList;
